/* eslint-disable class-methods-use-this */
import axios from "axios";
import { deobfuscateSearchCities } from "./utils/obfuscate";

class CityService {
  async getAllCities() {
    const { data: cities } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/cities`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      },
    );
    return cities;
  }

  async getCityById(id) {
    const { data: city } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/cities/${id}`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      },
    );
    return city;
  }

  async searchCities(filteredCityIds) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/cities/search`,
      {
        params: {
          filteredCityIds,
        },
      },
      {},
    );

    const normalized = deobfuscateSearchCities(data);
    return normalized;
  }

  async findCitylatlong(address, city, country) {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/cities/findlatlong-city`,
        {
          params: {
            address,
            city,
            country,
          },
          headers: {
            Authorization: `${localStorage.jwtToken}`,
          },
        },
      );

      return data;
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error en findCitylatlong:", error.response?.data || error);
      throw error;
    }
  }
}

const cityService = new CityService();

export default cityService;
